import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useCtaButton = () => {
  const [text, setText] = useState("Entre em Contato!");
  const [link, setLink] = useState("https://api.whatsapp.com/send?phone=5521977435758");

  useEffect(() => {
    const fetch = async () => {
      const { data } = await supabase
        .from("site_settings")
        .select("key, value")
        .in("key", ["cta_button_text", "cta_button_link"]);
      if (data) {
        data.forEach((row) => {
          if (row.key === "cta_button_text") setText(row.value as string);
          if (row.key === "cta_button_link") setLink(row.value as string);
        });
      }
    };
    fetch();
  }, []);

  return { text, link };
};
